<app-alert-box-component 
  (OnButtonClick)="onAlertButtonClick($event)"
  (OnAlertClose)="closeAlert($event)" 
  (OnAlertVisibility)="alertVisibility($event)"
  [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" 
  [alertBodyText]="alertBodyText" 
  [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText"
  [data]="alertBoxData"
  [bAlert]="bAlert"></app-alert-box-component>
  
<nav class="navbar navbar-expand-lg navbar-light fixed-top" id="navbar">
  <div class="bg-light dark:bg-transparent d-flex flex-row align-items-center">
    <c-input-group class="mb-4">
      <span cInputGroupText>
        <svg cIcon name="cifUs"></svg>
      </span>
      <select  #appLanguage aria-label="Language" [ngModel]="langValue" cSelect (change)="switchLanguage(appLanguage.value)">
        <option value="en">English</option>
        <option value="ar">عربي</option>
      </select>
    </c-input-group>
  </div>
</nav>


<div class="bg-light dark:bg-transparent min-vh-100 d-flex flex-row align-items-center">
  <c-container breakpoint="md">
    <c-row class="justify-content-center">
      <c-col lg="10" xl="8">
        <c-card-group>
          <c-card class="p-4" *ngIf="bShowLoginScreen">
            <c-card-body>
              <form
                [formGroup]="loginForm"
                (ngSubmit)="login()"
                [validated]="customStylesValidated"
                cForm
                class="row g-3 needs-validation"
                >
                <h1>{{'LOGIN.LOGIN_HEADER' | translate}}</h1>
                <p class="text-medium-emphasis">{{'LOGIN.LOGIN_MESSAGE' | translate}}</p>
                <c-input-group class="mb-3 has-validation" >
                  <span cInputGroupText id="inputGroupPrepend">@</span>
                  <input #username formControlName="username" name="username" required type="email" cFormControl placeholder="Email ID" email=true/>
                  <c-form-feedback [valid]="false">Please enter a valid email ID.</c-form-feedback>
                </c-input-group>
                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input formControlName="password" name="password" type="password" cFormControl placeholder="Password" required />
                  <c-form-feedback [valid]="false">Please enter a valid password</c-form-feedback>
                </c-input-group>
                <c-row>
                  <c-col xs="6">
                    <button cButton class="px-4" color="primary" type="submit">
                      <c-spinner *ngIf="bLoading" aria-hidden="true" size="sm"></c-spinner>
                      Login
                    </button>
                  </c-col>
                  <c-col class="text-right" xs="6">
                    <button cButton class="px-0" color="link" (click)="showScreen(false, true, false)">
                      Forgot password?
                    </button>
                  </c-col>
                </c-row>
                <p><small>Portal Version: {{appVersion}}</small></p>
              </form>
            </c-card-body>
          </c-card>
          <c-card class="p-4" *ngIf="bShowForgetPassword">
            <c-card-body>
              <form [formGroup]="resetPasswordForm"
                (ngSubmit)="resetPassword()"
                [validated]="customStylesValidated"
                cForm
                class="row g-3 needs-validation"
                >
                <h1>Forgot Password</h1>
                <p class="text-medium-emphasis">Recover your Dhabi account</p>
                <c-input-group class="mb-3 has-validation" >
                  <span cInputGroupText id="inputGroupPrepend">@</span>
                  <input formControlName="username" name="username" required type="email" cFormControl placeholder="Email ID" email=true/>
                  <c-form-feedback [valid]="false">Please choose an Email ID.</c-form-feedback>
                </c-input-group>
                <c-row>
                  <c-col xs="6">
                    <button cButton class="px-4" color="primary" type="submit">
                      <c-spinner *ngIf="bLoading" aria-hidden="true" size="sm"></c-spinner>
                      Request
                    </button>
                  </c-col>
                  <c-col class="text-right" xs="6">
                    <button cButton class="px-0" color="link" (click)="showScreen(true, false, false)">
                      Want to Login?
                    </button>
                  </c-col>
                </c-row>
              </form>
            </c-card-body>
          </c-card>
          <c-card class="p-4" *ngIf="bShowOTPScreen">
            <c-card-body>
              <form [formGroup]="otpForm"
                (ngSubmit)="validateOTP()"
                [validated]="customStylesValidated"
                cForm
                class="row g-3 needs-validation"
                >
                <h1>Validate your Email</h1>
                <p class="text-medium-emphasis">Enter the 6 digit OTP you have received</p>
                <c-input-group class="mb-3 has-validation" >
                  <ng-otp-input [formCtrl]="otpString" [config]="{length:6, allowNumbersOnly: true}"></ng-otp-input>
                </c-input-group>
                <c-row>
                  <c-col xs="6">
                    <button cButton class="px-4" color="primary" type="submit">
                      <c-spinner *ngIf="bLoading" aria-hidden="true" size="sm"></c-spinner>
                      Validate
                    </button>
                  </c-col>
                  <c-col class="text-right" xs="6">
                    <button cButton class="px-0" color="link" (click)="showScreen(true, false, false)">
                      Want to Login?
                    </button>
                  </c-col>
                </c-row>
              </form>
            </c-card-body>
          </c-card>
          <c-card [ngStyle]="{'minWidth.%': 44}" class="loginbgimg text-white bg-primary py-5">
            <c-card-body class="text-center">

            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>


